const vinListConstants = {
  LIMIT: 50,
};

export default vinListConstants;
